import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import { truncate } from "../../utils/commonComponent/truncate";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import { fetchQuery } from "../../utils/commonComponent/fetched";
import { DateisValid } from "../../utils/commonComponent/errorAlert";

const JobAssignHistoryModal = ({ open, onClose, row , permissions}) => {
  const [historyList, setHistoryList] = useState([]);

  const fetchHistory = async () => {
    if (!row?.id) return;

    try {
      const query = `SELECT jobAssignHistory.*, users.userName, e.name AS employeeName FROM jobAssignHistory
        LEFT JOIN userMaster AS users ON users.id = jobAssignHistory.userId
        LEFT JOIN employees e ON users.employeeId = e.id
        WHERE jobAssignHistory.observationSheetId = ${row.id} ORDER BY jobAssignHistory.id DESC`;

      const result = await fetchQuery(query);
      setHistoryList(result || []);
    } catch (error) {
      console.log(error);
    }
  };

  const deleteHistory = async (id) => {
  try {
    const confirmDelete = window.confirm("Are you sure want to delete this history?");
    if (!confirmDelete) return;
    await fetchQuery(`DELETE FROM jobAssignHistory WHERE id = ${id}`);
    setHistoryList((prev) => prev.filter((item) => item.id != id));
  } catch (error) {
    console.log("history  delete error", error);
  }
};

  useEffect(() => {
    if (open) {
      fetchHistory();
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle className="flex justify-between items-center">
        <span>Job Assign History</span>

        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <div className="flex justify-between mb-4 border p-3 rounded">
          <div>
            <span className="font-semibold">Customer Name : </span>
            {truncate(row?.inward_customerName || "-")}
          </div>
          <div>
            <span className="font-semibold">Job No : </span>
            {row?.jobRegister_jobNumber || "-"}
          </div>
          <div>
            <span className="font-semibold">Test Name : </span>
            {truncate(row?.materialTestings_testName || "-")}
          </div>
          <div>
            <span className="font-semibold">Test No : </span>
            {row?.observationSheet_testNumber || "-"}
          </div>
        </div>

        <div className="overflow-auto">
          <table className="min-w-full border text-sm">
            <thead className="bg-blue-50">
              <tr>
                <th className="border px-3 py-2 text-center">Sr No</th>
                <th className="border px-3 py-2 text-center">Assigned User</th>
                <th className="border px-3 py-2 text-center">Assign Date</th>
                {permissions.delete && permissions.allAccess && (
                  <th className="border px-3 py-2 text-center">Action</th>
                )}
              </tr>
            </thead>

            <tbody>
              {historyList.map((item, index) => (
                <tr key={item.id}>
                  <td className="border px-3 py-2 text-center">{index + 1}</td>
                  <td className="border px-3 py-2 text-center">
                    {item.employeeName || "-"}
                    {item.userName ? ` (${item.userName})` : ""}
                  </td>
                  <td className="border px-3 py-2 text-center">
                    {DateisValid(item.assignDate, "DD/MM/YYYY", true)}
                  </td>
                  {permissions.delete && permissions.allAccess && (
                    <td className="border px-3 py-2 text-center">
                      <button
                        onClick={() => deleteHistory(item.id)}
                        className="text-red-600 hover:text-red-800"
                      >
                        <DeleteIcon fontSize="small" />
                      </button>
                    </td>
                  )}
                </tr>
              ))}

              {historyList.length == 0 && (
                <tr>
                  <td colSpan={4} className="border px-3 py-3 text-center">
                    No History Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default JobAssignHistoryModal;